console.log('components');

import './components/main';
